import React, { useState, useEffect } from "react";
import Aux from "../../../hoc/Auxilliary";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  IconButton,
} from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import FormStyle from "./prospective.module.css";
import FormBuilder from "../../FormBuilder";
import FormHeader from "../../FormHeader";
import {
  getApplications,
  updatePostSchoolInfo,
  deletePreviousSchool,
  getPreviousSchoolData,
} from "../../../reduxSlices/applicationSlice";
import { validateApplicationForm } from "../../../helpers/validateApplicationForm";
import { dateLogic } from "../../../helpers/dateLogic";

// Import localized strings
import localizedStrings from "../../../utils/localize";

const useStyles = makeStyles((theme) => ({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
  formDesign: {
    width: "98%",
    margin: "0 auto",
  },
  addbutton: {
    paddingLeft: "32rem",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "24rem",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "12rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "4rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "4rem",
    },
  },
  bottomButtons: {
    paddingLeft: "27rem",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "24rem",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "15rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "5rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "1rem",
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const Page6 = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);
  const [dateErrorMessage, setDateErrorMessage] = useState("");
  const data = props?.applicationJsonData || [];
  const applicationResultData = useSelector(
    (state) => state.applicationData.applicationJsonData,
  );
  const [displaySchoolForm, setDisplaySchoolForm] = useState(false);

  const [disabled, setDisabled] = useState(false);

  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  useEffect(() => {
    if (props.applicationIdValue) {
      const validateForm = validateApplicationForm(5, null, data, null);
      setDisabled(validateForm);
    }

    const msg = dateLogic(data, 6, localizedStrings);
    setDateErrorMessage(msg);
    if (msg !== "" && data.usb_currentdegreestatus === 943240001) {
      setDisabled(true);
    }
  }, [data, language]);

  const textFieldChangeHandlerForApplication = (event, key) => {
    const updatedData = {
      ...data,
      [event.target.name]: event.target.value,
    };
    props.setApplicationJsonData(updatedData);
  };

  const handleChangeforApplication = (event) => {
    let updatedData = {
      ...data,
      [event.target.name]: event.target.value,
    };

    if (event.target.name === "usb_currentdegreestatus") {
      updatedData = {
        ...data,
        [event.target.name]: event.target.value,
        usb_graduationdate:
          event.target.value === 943240001 ? null : data.usb_graduationdate,
        end_date_year: null,
        end_date_month: null,
        start_date_month: null,
        start_date_year: null,
      };
    }

    if (event.target.name === "usb_schooltype") {
      dispatch(getPreviousSchoolData(event.target.value));
    }
    props.setApplicationJsonData(updatedData);
    setDateErrorMessage("");
  };

  const handleDeleteSchool = (id) => {
    dispatch(deletePreviousSchool(id));
    setTimeout(() => {
      dispatch(getApplications(props.applicationIdValue, 284210002));
      props.setApplicationJsonData(applicationResultData);
    }, 2000);
  };

  const getLocalizedDegreeStatus = (status, localizedStrings) => {
    const localizedMapping = {
      943240000: localizedStrings.applicationpage.currentlystudying,
      943240001: localizedStrings.applicationpage.graduated,
      943240002: localizedStrings.applicationpage.nolongerstudying,
    };
    return localizedMapping[status] || "";
  };
  const getLocalizedEducationLevel = (level, localizedStrings) => {
    const localizedMapping = {
      943240000: localizedStrings.applicationpage.college,
      943240001: localizedStrings.applicationpage.university,
      943240002: localizedStrings.applicationpage.cegep,
    };
    return localizedMapping[level] || "";
  };

  let tableData = "";

  if (data?.previousEducation) {
    tableData =
      data?.previousEducation?.length > 0
        ? data?.previousEducation.map((element, index) => {
            return (
              <StyledTableRow key={index}>
                <StyledTableCell component="th" scope="row">
                  {getLocalizedEducationLevel(
                    element.usb_educationlevel,
                    localizedStrings,
                  )}
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {
                    element[
                      "_usb_schoolname_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {element.usb_startdate}
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {element.usb_enddate}
                </StyledTableCell>
                <StyledTableCell style={{ width: "200px" }}>
                  {getLocalizedDegreeStatus(
                    element.usb_currentdegreestatus,
                    localizedStrings,
                  )}
                </StyledTableCell>
                <StyledTableCell>{element.usb_graduationdate}</StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    color="secondary"
                    aria-label="delete"
                    onClick={() =>
                      handleDeleteSchool(element.usb_previouseducationrecordid)
                    }
                    component="span"
                  >
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            );
          })
        : null;
  }

  const addSchool = () => {
    setDisplaySchoolForm(true);
    props.setDisabledNextValue(true);
    props.setDisabledSaveValue(true);
    props.setDisabledPrevValue(true);
  };

  const handleSaveSchool = () => {
    const schoolLevel = 284210002;
    const {
      usb_schooltype,
      usb_secondaryschoolname0,
      usb_secondaryschoolname1,
    } = data;
    let schoolname, schooltype;

    switch (usb_schooltype) {
      case 943240003:
        schoolname = usb_secondaryschoolname0;
        schooltype = 943240003;
        break;
      case 943240004:
        schoolname = usb_secondaryschoolname1;
        schooltype = 943240004;
        break;
      default:
        schoolname = null;
    }

    let postSchoolData = {
      usb_educationlevel: data.usb_educationlevel,
      usb_startdate: `${data.start_date_month}/${data.start_date_year}`,
      usb_graduationdate: `${data.usb_graduationdate}`,
      usb_currentdegreestatus: data.usb_currentdegreestatus,
      _usb_schoolname_value: schoolname,
      usb_schooltype: schooltype,
      schoolLevel: schoolLevel,
    };

    if (data.end_date_month !== null && data.end_date_year !== null) {
      postSchoolData.usb_enddate = `${data.end_date_month}/${data.end_date_year}`;
    }

    dispatch(updatePostSchoolInfo(postSchoolData, props.applicationIdValue));

    setTimeout(() => {
      handleCancelSchool();
    }, 1600);
  };

  const handleCancelSchool = () => {
    setDisplaySchoolForm(false);
    dispatch(getApplications(props.applicationIdValue, 284210002));
    props.setApplicationJsonData(applicationResultData);
    props.setDisabledNextValue(false);
    props.setDisabledSaveValue(false);
    props.setDisabledPrevValue(false);
  };
  return (
    <Aux>
      <Grid xs={12}>
        <Grid style={{ padding: "0 2.5rem" }}>
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader
              name={
                localizedStrings.applicationpage.previouseducationpostsecondary
              }
            />
            <div className={classes.formDesign}>
              {localizedStrings.applicationpage.surcettepage}
              <Typography
                component="div"
                className={classes.classFont}
                style={{ marginTop: "1rem" }}
              >
                {localizedStrings.applicationpage.copieofficielle}
                <br />
                {localizedStrings.applicationpage.inscriptionetablissement}{" "}
                <a href="mailto:admissions@ustboniface.ca">
                  admissions@ustboniface.ca
                </a>
                .
                <br />
                {localizedStrings.applicationpage.sansetablissement}
              </Typography>
              <br />
              {localizedStrings.applicationpage.fournistrenseignements}
              <TableContainer
                component={Paper}
                style={{ minHeight: "40vh", marginBottom: "10px" }}
              >
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.labels.educationlevel}
                      </StyledTableCell>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.schoolname}
                      </StyledTableCell>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.startdate}
                      </StyledTableCell>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.enddate}
                      </StyledTableCell>
                      <StyledTableCell>
                        {
                          localizedStrings.applicationpage.labels
                            .currentdegreestatus
                        }
                      </StyledTableCell>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.graduationdate}
                      </StyledTableCell>
                      <StyledTableCell>
                        {localizedStrings.applicationpage.deleteschool}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{tableData}</TableBody>
                </Table>
              </TableContainer>
              <br />
              <Grid
                container
                justifyContent="center"
                spacing={2}
                className={classes.addbutton}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={addSchool}
                  >
                    {localizedStrings.applicationpage.addschool}
                  </Button>
                  <br />
                </Grid>
              </Grid>
              <br />
              {displaySchoolForm && (
                <>
                  {localizedStrings.applicationpage.fournischoolinfo}
                  <br />
                  <FormBuilder
                    formDetails={props.formDatatwo}
                    value={data}
                    handleChange={handleChangeforApplication}
                    changed={textFieldChangeHandlerForApplication}
                  />
                  {
                    localizedStrings.applicationpage
                      .monthandyeardidyoustartattendingthisschool
                  }
                  <FormBuilder
                    formDetails={props.formDatathree}
                    value={data}
                    handleChange={handleChangeforApplication}
                    changed={textFieldChangeHandlerForApplication}
                  />
                  {
                    localizedStrings.applicationpage
                      .monthandyeardidyoufinishyourstudiesattheschool
                  }
                  <FormBuilder
                    formDetails={props.formDatafour}
                    value={data}
                    handleChange={handleChangeforApplication}
                    changed={textFieldChangeHandlerForApplication}
                  />
                  {dateErrorMessage && (
                    <p style={{ color: "red" }}>{dateErrorMessage}</p>
                  )}
                  <Grid
                    container
                    justifyContent="center"
                    spacing={2}
                    className={classes.bottomButtons}
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCancelSchool}
                      >
                        {localizedStrings.applicationpage.cancelschool}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSaveSchool}
                        disabled={disabled}
                      >
                        {localizedStrings.applicationpage.saveschool}
                      </Button>
                    </Grid>
                    <br />
                  </Grid>
                </>
              )}
            </div>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Page6;
